import React from 'react';
import PropTypes from 'prop-types';

import { MobileNav } from './index';

class MobileNavContainer extends React.Component {
  componentWillUnmount() {
    document.body.classList.remove('lockScroll');
  }

  render() {
    const {
      links,
      isSignedIn,
      onLogOut,
      isVisible,
      pathname,
      onClickClose,
    } = this.props;
    return (
      <MobileNav
        pathname={pathname}
        links={links}
        isSignedIn={isSignedIn}
        onClickClose={onClickClose}
        isVisible={isVisible}
        onLogOut={onLogOut}
      />
    );
  }
}

MobileNavContainer.defaultProps = {
  onLogOut: () => {},
  onClickClose: () => {},
  pathname: null,
};

MobileNavContainer.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      href: PropTypes.string,
      to: PropTypes.string,
      isShowingNotificationBadge: PropTypes.bool,
      notificationBadge: PropTypes.string,
    })
  ).isRequired,
  isSignedIn: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  onLogOut: PropTypes.func,
  onClickClose: PropTypes.func,
  pathname: PropTypes.string,
};

export { MobileNavContainer };
